var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "combinedsearch" },
    [
      _c(
        "div",
        { staticClass: "common-header" },
        [
          _c("common-header", {
            attrs: {
              headerList: [
                { label: "首页", url: "/" },
                { label: "综合搜索", url: "" }
              ]
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "combinedsearch-top" },
        [
          _c("div", { staticClass: "combinedsearch-system" }),
          _c("SearchBox", {
            ref: "searchBox",
            attrs: { selectSys: _vm.systemId, searchTitle: _vm.searchVal },
            on: { searchCommon: _vm.searchTitle, setSysId: _vm.setSysId }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "combinedsearch-bot"
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            _vm._l(_vm.list, function(item, index) {
              return _c(
                "el-tab-pane",
                {
                  key: index,
                  attrs: {
                    name: item.systemId,
                    label: _vm.systemList[item.systemId]
                  }
                },
                [
                  _c("div", { staticClass: "Category" }, [
                    item.systemId == "LC_RI"
                      ? _c(
                          "div",
                          { staticClass: "Category-top" },
                          _vm._l(item.Category, function(ele, num) {
                            return _c(
                              "div",
                              {
                                key: num,
                                staticClass: "Category-top-item",
                                class: { activeClass: _vm.cateGoryName == num },
                                on: {
                                  click: function($event) {
                                    return _vm.tabClick(
                                      ele.tabCategoryName,
                                      item.systemId,
                                      num,
                                      ele.tabCategoryId
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      ele.tabCategoryName ||
                                        _vm.categoryObj[ele.tabCategoryId] ||
                                        ""
                                    ) +
                                    "(" +
                                    _vm._s(ele.totalCount) +
                                    ") "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : item.systemId == "LC_FAQ"
                      ? _c(
                          "div",
                          { staticClass: "Category-top" },
                          _vm._l(item.Category.categoryInfos, function(
                            ele,
                            num
                          ) {
                            return _c(
                              "div",
                              {
                                key: num,
                                staticClass: "Category-top-item",
                                class: { activeClass: _vm.cateGoryName == num },
                                on: {
                                  click: function($event) {
                                    return _vm.tabClick(
                                      ele.categoryName,
                                      item.systemId,
                                      num,
                                      ele.cid
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(ele.categoryName || "") +
                                    "(" +
                                    _vm._s(ele.summaryCount) +
                                    ") "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : item.systemId == "LC_REGULATORY_TRENDS"
                      ? _c(
                          "div",
                          { staticClass: "Category-top" },
                          _vm._l(
                            item.Category[0]
                              ? item.Category[0].searchRespAll.publishOrgInfo
                              : [],
                            function(ele, num) {
                              return _c(
                                "div",
                                {
                                  key: num,
                                  staticClass: "Category-top-item",
                                  class: {
                                    activeClass: _vm.cateGoryName == num
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.tabClick(
                                        ele.publishOrgName,
                                        item.systemId,
                                        num,
                                        ele.publishOrgId
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(ele.publishOrgName || "") +
                                      "(" +
                                      _vm._s(ele.summaryCount) +
                                      ") "
                                  )
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : item.systemId == "LC_PUNISH"
                      ? _c(
                          "div",
                          { staticClass: "Category-top" },
                          _vm._l(
                            item.Category[0]
                              ? item.Category[0].searchRespAll.punishOrgInfos
                              : [],
                            function(ele, num) {
                              return _c(
                                "div",
                                {
                                  key: num,
                                  staticClass: "Category-top-item",
                                  class: {
                                    activeClass: _vm.cateGoryName == num
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.tabClick(
                                        ele.punishOrgName,
                                        item.systemId,
                                        num,
                                        ele.punishOrgId
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(ele.punishOrgName || "") +
                                      "(" +
                                      _vm._s(ele.summaryCount) +
                                      ") "
                                  )
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : item.systemId == "LCC"
                      ? _c("div")
                      : _c(
                          "div",
                          { staticClass: "Category-top" },
                          _vm._l(item.Category, function(ele, num) {
                            return _c(
                              "div",
                              {
                                key: num,
                                staticClass: "Category-top-item",
                                class: { activeClass: _vm.cateGoryName == num },
                                on: {
                                  click: function($event) {
                                    return _vm.tabClick(
                                      ele.tabCategoryName,
                                      item.systemId,
                                      num,
                                      ele.tabCategoryId
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(ele.tabCategoryName || "") +
                                    "(" +
                                    _vm._s(ele.totalCount) +
                                    ") "
                                )
                              ]
                            )
                          }),
                          0
                        )
                  ])
                ]
              )
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "Category-bot" },
            [
              _vm._l(_vm.resultList.length > 0 ? _vm.resultList : [], function(
                item,
                index
              ) {
                return _c(
                  "div",
                  { key: index, staticClass: "Category-bot-item" },
                  [
                    _vm.systemId == "LC_IE"
                      ? [
                          _c(
                            "div",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  return _vm.toNewPage(item.instId)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "Category-bot-item-title",
                                domProps: { innerHTML: _vm._s(item.title) }
                              }),
                              _c(
                                "div",
                                { staticClass: "Category-bot-item-attr" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "Category-bot-item-attr-content"
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.publishOrgName) + " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "Category-bot-item-attr-content"
                                    },
                                    [_vm._v(" " + _vm._s(item.issueNum) + " ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "Category-bot-item-attr-content"
                                    },
                                    [_vm._v(_vm._s(item.publishDate) + "发布")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "Category-bot-item-attr-content"
                                    },
                                    [_vm._v(_vm._s(item.viewCount) + "次阅读")]
                                  )
                                ]
                              ),
                              item.summary
                                ? _c("div", {
                                    staticClass: "Category-bot-item-desc",
                                    staticStyle: {
                                      overflow: "hidden",
                                      "white-space": "nowrap",
                                      "text-overflow": "ellipsis",
                                      height: "22px"
                                    },
                                    attrs: {
                                      title: _vm.replaceStr(item.summary)
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(item.summary)
                                    }
                                  })
                                : _vm._e(),
                              item.contentFragment
                                ? _c("div", {
                                    staticClass: "Category-bot-item-desc",
                                    staticStyle: { "margin-top": "10px" },
                                    attrs: {
                                      title: _vm.replaceStr(
                                        item.contentFragment
                                      )
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(item.contentFragment)
                                    }
                                  })
                                : _vm._e()
                            ]
                          )
                        ]
                      : _vm._e(),
                    _vm.systemId == "LC_RI"
                      ? [
                          _c(
                            "div",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  return _vm.toNewPage(item.regId)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "Category-bot-item-title",
                                domProps: { innerHTML: _vm._s(item.title) }
                              }),
                              _c(
                                "div",
                                { staticClass: "Category-bot-item-attr" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "Category-bot-item-attr-content",
                                      staticStyle: { "margin-right": "0" }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.publishOrg) + " "
                                      ),
                                      _c(
                                        "span",
                                        { staticStyle: { margin: "0 3px" } },
                                        [_vm._v("·")]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "Category-bot-item-attr-content",
                                      staticStyle: { "margin-right": "0" }
                                    },
                                    [
                                      _vm._v(" " + _vm._s(item.issueNum) + " "),
                                      _c(
                                        "span",
                                        { staticStyle: { margin: "0 3px" } },
                                        [_vm._v("·")]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "Category-bot-item-attr-content"
                                    },
                                    [_vm._v(_vm._s(item.publishDate) + "发布")]
                                  )
                                ]
                              ),
                              _c("div", {
                                staticClass: "Category-bot-item-desc",
                                domProps: {
                                  innerHTML: _vm._s(item.highlightContent)
                                }
                              })
                            ]
                          )
                        ]
                      : _vm._e(),
                    _vm.systemId == "LC_FAQ"
                      ? [
                          _c("div", [
                            _c("div", {
                              staticClass: "Category-bot-item-title",
                              staticStyle: { cursor: "pointer" },
                              domProps: { innerHTML: _vm._s(item.question) },
                              on: {
                                click: function($event) {
                                  return _vm.toNewPageFaq(
                                    item.question,
                                    item.qid,
                                    item.cid
                                  )
                                }
                              }
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "Category-bot-item-attr",
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "Category-bot-item-attr-content",
                                    staticStyle: { flex: "1" }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "margin-right": "16px" }
                                      },
                                      [_vm._v("分类：" + _vm._s(item.path))]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        " 联系人：" +
                                          _vm._s(
                                            item.contactName
                                              ? item.contactName
                                              : "无"
                                          ) +
                                          "(联系方式：" +
                                          _vm._s(
                                            item.contactInfo
                                              ? item.contactInfo
                                              : "无"
                                          ) +
                                          ") "
                                      )
                                    ])
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "Category-bot-item-attr-content"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "margin-right": "16px" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(item.viewcount) + "次阅读"
                                        )
                                      ]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(item.modifiedTime) + " 更新"
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "Category-bot-item-answer" },
                              [
                                _c("div", { staticClass: "keypoint" }, [
                                  _c(
                                    "div",
                                    { class: { hide: item.isHideDetail } },
                                    [
                                      _vm._v(" 【解答要点】 "),
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(item.answer)
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "Category-bot-item-analysis-wrapper"
                              },
                              [
                                _c("div", { staticClass: "anlysis" }, [
                                  _c(
                                    "div",
                                    { class: { hide: item.isHideDetail } },
                                    [
                                      _vm._v(" 【法律分析】 "),
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(item.legalAnalysis)
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                item.isHideDetail
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "redmore",
                                        on: {
                                          click: function($event) {
                                            return _vm.readmore(item)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(" 阅读详情 "),
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            !item.isHideDetail
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "Category-bot-item-more-quesions"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "relatedQ-title" },
                                      [
                                        item.relatedQuestions &&
                                        item.relatedQuestions.length > 0
                                          ? _c("span", [
                                              _c("span", {
                                                staticClass:
                                                  "icon relatedQuestion"
                                              }),
                                              _vm._v(" 关联问题 ")
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "relatedQ-wrapper" },
                                      _vm._l(item.relatedQuestions, function(
                                        question,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "relatedQ",
                                            attrs: { title: question.question },
                                            on: {
                                              click: function($event) {
                                                return _vm.showRelatedQuestionModal(
                                                  question
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(question.question) +
                                                " "
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "Category-bot-item-keywords" },
                              [
                                _vm._l(
                                  item.regulationInternal.slice(0, 2),
                                  function(law, index) {
                                    return _c(
                                      "span",
                                      { key: index, staticClass: "ghost red" },
                                      [_vm._v(" " + _vm._s(law) + " ")]
                                    )
                                  }
                                ),
                                _vm._l(
                                  item.regulationExternal.slice(0, 2),
                                  function(law, index) {
                                    return _c(
                                      "span",
                                      {
                                        key: index,
                                        staticClass: "ghost yellow2"
                                      },
                                      [_vm._v(" " + _vm._s(law) + " ")]
                                    )
                                  }
                                ),
                                _c("span", { staticClass: "comment" }),
                                !item.isHideDetail
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "collspe",
                                        on: {
                                          click: function($event) {
                                            return _vm.hideDetail(item)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(" 收起 "),
                                        _c("i", {
                                          staticClass: "el-icon-arrow-up"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          ])
                        ]
                      : _vm._e(),
                    _vm.systemId == "LC_REGULATORY_TRENDS"
                      ? [
                          _c(
                            "div",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  return _vm.toNewPage(
                                    item.regulatoryTrendsId || item.id
                                  )
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "Category-bot-item-title",
                                domProps: { innerHTML: _vm._s(item.title) }
                              }),
                              _c(
                                "div",
                                { staticClass: "Category-bot-item-attr" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "Category-bot-item-attr-content"
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.publishChannel) + " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "Category-bot-item-attr-content"
                                    },
                                    [_vm._v(_vm._s(item.publishDate) + "发布")]
                                  ),
                                  _c("div", {
                                    staticClass:
                                      "Category-bot-item-attr-content"
                                  })
                                ]
                              ),
                              _c("div", {
                                staticClass: "Category-bot-item-desc ",
                                staticStyle: {
                                  width: "100%",
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                  "-webkit-line-clamp": "2",
                                  display: "block"
                                },
                                domProps: {
                                  innerHTML: _vm._s(item.highlightContent)
                                }
                              })
                            ]
                          )
                        ]
                      : _vm._e(),
                    _vm.systemId == "LC_PUNISH"
                      ? [
                          _c(
                            "div",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  return _vm.toNewPage(item.id)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "Category-bot-item-title",
                                domProps: { innerHTML: _vm._s(item.title) }
                              }),
                              _c(
                                "div",
                                { staticClass: "Category-bot-item-attr" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "Category-bot-item-attr-content"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.punishedOrg) +
                                          " · " +
                                          _vm._s(item.documentNo) +
                                          " · " +
                                          _vm._s(item.punishmentDate) +
                                          "发布 "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c("div", {
                                staticClass: "Category-bot-item-desc",
                                domProps: { innerHTML: _vm._s(item.summary) }
                              })
                            ]
                          )
                        ]
                      : _vm._e(),
                    _vm.systemId == "LCC"
                      ? [
                          _c(
                            "div",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  return _vm.toNewPage(
                                    item.contractId,
                                    item.pdfContentId
                                  )
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "Category-bot-item-title",
                                domProps: {
                                  innerHTML: _vm._s(item.contractTitle)
                                }
                              }),
                              _c(
                                "div",
                                { staticClass: "Category-bot-item-attr" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "Category-bot-item-attr-content"
                                    },
                                    [
                                      _vm._v(
                                        "启用日期：" +
                                          _vm._s(item.effectiveDate)
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "Category-bot-item-attr-content"
                                    },
                                    [
                                      _vm._v(
                                        "拟稿部门：" + _vm._s(item.publishOrg)
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "Category-bot-item-attr-content"
                                    },
                                    [
                                      _vm._v(
                                        " 合同业务分类：" +
                                          _vm._s(item.businessType) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "Category-bot-item-attr-content"
                                    },
                                    [_vm._v("版本状态：" + _vm._s(item.status))]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "Category-bot-item-desc2" },
                                [_vm._v("浏览次数：" + _vm._s(item.viewCount))]
                              )
                            ]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              }),
              _vm.resultList.length == 0 && !_vm.loading
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "center"
                      }
                    },
                    [
                      _c("no-data", {
                        attrs: { height: "400px", width: "400px" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.resultList.length == 10
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        margin: "0 auto",
                        "text-align": "center",
                        "background-color": "#fff"
                      }
                    },
                    [
                      _c(
                        "p",
                        {
                          staticStyle: {
                            width: "100px",
                            margin: "0 auto",
                            height: "40px",
                            cursor: "pointer",
                            "font-size": "14px",
                            "font-family": "PingFangSC, PingFangSC-Regular",
                            "font-weight": "400",
                            color: "#999999",
                            "line-height": "40px"
                          },
                          on: { click: _vm.getMore }
                        },
                        [_vm._v(" 点击查看更多 ")]
                      )
                    ]
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog_footer_btn dialog_relation",
          attrs: {
            title: _vm.relationTitel,
            visible: _vm.showRelation,
            top: "5vh",
            width: "85%"
          },
          on: {
            "update:visible": function($event) {
              _vm.showRelation = $event
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "relationTitel",
              attrs: { slot: "title" },
              slot: "title"
            },
            [_vm._v(_vm._s(_vm.relationTitel))]
          ),
          _c("DialogQusetion", {
            attrs: {
              DialogQuestion: _vm.DialogQuestion,
              relatedDialogQuestion: _vm.relatedDialogQuestion
            },
            on: { showRelatedQuestionModal: _vm.showRelatedQuestionModal }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }